import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {SelectPure, InputContainer} from '@modifi/ui'
import {FormDataContext, FormInput} from '@modifi/plugin-forms'
import {useTranslation} from '@modifi/plugin-i18n'

import {RequiredLabel} from '../../styles'

const SelectWithContainer = props => <InputContainer inputComponent={SelectPure} {...props} />

const CountrySelectInput = ({countryOptions, janusTrans}) => {
  const {t} = useTranslation('pkg:forms')
  const {changeData, data} = useContext(FormDataContext)

  const handleChange = updatedData => {
    if (!data?.countryCode) {
      changeData('countryCode', updatedData?.value)
    }
  }
  return (
    <FormInput
      name="country"
      inputComponent={SelectWithContainer}
      t={t}
      label={<RequiredLabel>{janusTrans('signup.country.label')}</RequiredLabel>}
      placeholder={janusTrans('signup.country.placeholder')}
      options={countryOptions}
      oneOf={countryOptions.map(({value}) => value)}
      oneOfMessage="tr:country.error.one-of"
      noBlur
      onChange={handleChange}
    />
  )
}

CountrySelectInput.propTypes = {
  countryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  janusTrans: PropTypes.func.isRequired,
}

export default CountrySelectInput
